import { action, observable } from 'mobx';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { TrustData } from './type';

class SecurityStore {
    @observable
    otp_enable: boolean;

    @action
    updateOtpEnable(flag?: boolean) {
        this.otp_enable = Boolean(flag);
    }

    // 获取配置
    getSettings() {
        return http.get<{ otp_enable: boolean; set_security_question: boolean }>(API.OAUTH.userSetting());
    }

    // 关闭两步验证
    off2fa(params) {
        const newParams = { ...params };

        return http.post(API.OAUTH.otp.off(), newParams);
    }

    on2fa(params) {
        return http.post(API.OAUTH.otp.on(), params);
    }

    // 设置两步验证位置
    setPosition(params) {
        return http.post(API.OAUTH.otp.setting(), params);
    }

    getTrust() {
        return http.get<TrustData>(API.CUSTOMER.getTrustedPerson()).then(res => res.data);
    }

    // 获取消息订阅状态
    getMarketingSetting() {
        return http
            .get<{ EMAIL: Array<{ fieldName: string; enabledSend: boolean }> }>(API.MS.getMessageSetting(), {
                params: {
                    uuid: security.currentUser?.userInfo.uuid
                }
            })
            .then(res => res.data?.EMAIL?.filter(item => item.fieldName === 'business')[0]);
    }

    /**
     * 提交用户设置
     * @param enabledSend 表示订阅（true）或退订（false）
     */
    updateMarketingSetting(enabledSend: boolean) {
        return http.post(API.MS.submitMessageSetting(), {
            uuid: security.currentUser?.userInfo.uuid,
            messageType: 'EMAIL',
            manageType: 'channel',
            items: [{ fieldName: 'business', enabledSend }]
        });
    }

    // 获取ib名字
    getIBName() {
        return security.currentCustomerId
            ? http
                  .get<{ ib_username: string }>(API.CUSTOMER.getAccountInfo(), {
                      params: {
                          customer_id: security.currentCustomerId
                      }
                  })
                  .then(res => res.data)
            : Promise.resolve(null);
    }
}

export default new SecurityStore();
